(function () {
    "use strict";

    angular.module("app").component("screeningFvmRow", {
        template: `<div ng-include="getTemplate()">`,
        bindings: {
            s: "=",
            groupKey: "@",
            groupKeyStatus: "@",
            filter: "=",
            open: "=?",
            download: "=?",
            accept: "=?",
            reopen: "=?",
            stop: "=?",
            app: "=",
            parentState: "=",
            onReload: "=?"
        },
        controller: ScreeningFvmRowController
    });

    ScreeningFvmRowController.$inject = ["$rootScope", "$scope", "enumService", "$filter", "habilBootbox",];
    function ScreeningFvmRowController($rootScope, $scope, enumService, $filter, habilBootbox) {
        const $controller = this;
        const translator = $filter("habilTranslation");

        $controller.GetDetails = getDetails;
        $controller.CanOpen = canOpen;
        $controller.CanReopen = canReopen;
        $controller.CanAnswer = canAnswer;
        $controller.CanStop = canStop;
        $controller.CanDownload = canDownload;
        $controller.ShowMotivation = showMotivation;
        $controller.hasActions = hasActions;

        $scope.getTemplate = function () {
            switch ($controller.s.Type.toLowerCase()) {
                case "organisation":
                    return "@/screening/fvm.html";
                case "individual":
                    return "@/screening/ivm.html";
            }

            return "screening/fvm.html";
        };

        $scope.isCompleted = () => isScreeningInStatus(enumService.ScreeningStatusCode.Completed);
        $scope.isAccepted = () => isScreeningInStatus(enumService.ScreeningStatusCode.Accepted);
        $scope.isReadOnly = () => isScreeningInStatus(enumService.ScreeningStatusCode.ReadOnly);
        
        $scope.filterNew = () => isFilteringOnStatus(enumService.ScreeningStatusCode.New);
        $scope.filterCompleted = () => isFilteringOnStatus(enumService.ScreeningStatusCode.Completed);
        $scope.filterAccepted = () => isFilteringOnStatus(enumService.ScreeningStatusCode.Accepted);
        $scope.filterReturned = () => isFilteringOnStatus(enumService.ScreeningStatusCode.Retour);
        $scope.filterRejected = () => isFilteringOnStatus(enumService.ScreeningStatusCode.Rejected);

        $scope.isAlreadyProcessed = isAlreadyProcessed;
        function isAlreadyProcessed(screening) {
            const filterStatus = Number.parseInt($controller.filter.Status);

            return filterStatus !== screening.Status;
        }

        function getAlreadyProcessedText(screening) {
            if (isFilteringOnStatus(enumService.ScreeningStatusCode.New) && screening.Status == enumService.ScreeningStatusCode.Accepted) {
                return translator("Screening_AlreadyAccepted");
            }

            switch (screening.Status) {
                case enumService.ScreeningStatusCode.New:
                    return translator("Screening_NotAcceptedYet");
                case enumService.ScreeningStatusCode.Accepted:
                    return translator("Screening_Result_StillOpen");
                case enumService.ScreeningStatusCode.Completed:
                case enumService.ScreeningStatusCode.Retour:
                    return getTextWithResult("Screening_Result_AlreadySet", screening.ResultCode);
                case enumService.ScreeningStatusCode.Confirmed:
                case enumService.ScreeningStatusCode.Processed:
                    return getTextWithResult("Screening_Result_AlreadySigned", screening.ResultCode);
                case enumService.ScreeningStatusCode.Rejected:
                    return translator("Screening_SentBackTo_NSA");
                case enumService.ScreeningStatusCode.Stopped:
                    return translator("ZeroStatus_Recall_Screening");
            }

            return "";
        }

        function getTextWithResult(translationKey, resultCode) {
            const text = translator(translationKey);

            const result = $rootScope.codeScreeningResults.find(c => c.Key === resultCode);
            if (result)
                return `${text} (${result.Value})`;
            else
                return text;
        }

        $scope.CanReopen = canReopen;
        function canReopen() {
            if (!$controller.s || !$controller.s.Screening)
                return false;

            const screening = $controller.s.Screening;

            const filterStatus = Number.parseInt($controller.filter.Status);

            switch (filterStatus) {
                case enumService.ScreeningStatusCode.Accepted:
                case enumService.ScreeningStatusCode.Completed:
                case enumService.ScreeningStatusCode.Retour:
                case enumService.ScreeningStatusCode.Rejected:
                    return screening.Status == enumService.ScreeningStatusCode.Retour || screening.Status == enumService.ScreeningStatusCode.Completed;
            }

            return false;
        }

        function canOpen() {
            if (!$controller.s || !$controller.s.Screening)
                return false;

            const type = $controller.s.Type.toLowerCase();

            return ["organisation", "individual"].some(t => type === t);
        }

        function canAnswer() {
            if (isFilteringOnStatus(enumService.ScreeningStatusCode.Accepted)) {
                return $scope.isAccepted();
            }
        }

        function canStop() {
            const request = $controller.s;

            return request.Status == enumService.FvmStatusCodes.ConfirmationGivenToStopScreening;
        }

        function canDownload() {
            if (!$controller.filter || !$controller.s.Screening)
                return false;

            const filterStatusCode = Number.parseInt($controller.filter.Status);
            const screening = $controller.s.Screening;

            return filterStatusCode !== enumService.ScreeningStatusCode.New && screening.Status !== enumService.ScreeningStatusCode.Stopped;
        }

        /**
         * Generates a string containing extra information depending on the status of the 
         * (possibly missing) screening.
         * Examples:
         * - Teruggestuurd naar de NVO
         * - Onderzoek is reeds voltooid (RAS)
         * - Geen kennisname-verklaring
         * - Aanvraag is nog lopende
         */
        function getDetails() {
            const request = $controller.s;

            if (!request)
                return "";

            switch (request.Type.toLowerCase()) {
                case "individual":
                    return getDetailsForIndividual(request);
                case "organisation":
                    return getDetailsForOrganisation(request);
            }
        }

        $scope.toggleOpen = (s) => s.Open = !s.Open;

        function isScreeningInStatus(status) {
            if (!$controller.s || !$controller.s.Screening)
                return false;

            return status == $controller.s.Screening.Status;
        }

        function getDetailsForOrganisation(fvm) {
            const screening = fvm.Screening;

            if (!screening) {
                return translator("Screening_RequestPending");
            }

            const date = fvm.ClearanceEndDate;

            if (date instanceof Date) {
                const clearanceDate = $filter("date")(date, "dd/MM/yyyy");
                return `${translator("COL_Person_HasAlreadyVM_Until")}${clearanceDate}`;
            }

            if (isFilteringOnStatus(screening.Status)) {
                return getDefaultDetails(screening.Status, screening.ResultCode);
            }

            return getAlreadyProcessedText(screening);
        }

        function getDetailsForIndividual(person) {
            const screening = person.Screening;

            if (!screening) {
                if (person.PersonAction === enumService.PersonActionCodes.NoAcknowledgement) {
                    return translator("NoAcknowledgment_Title");
                }

                if (person.PersonAction === enumService.PersonActionCodes.NoAction) {
                    return translator("NoAction_Title");
                }

                if (person.PersonAction === null) {
                    return translator("Organisation_Appointee_Dont_Use");
                }

                return translator("Screening_RequestPending");
            }

            //When the IVM Screening is in state ReadOnly there is already a valid clearance found for this person
            if (screening.Status == enumService.ScreeningStatusCode.ReadOnly) {
                const date = person.ClearanceEndDate;

                if (date instanceof Date) {
                    const clearanceDate = $filter("date")(date, "dd/MM/yyyy");
                    return `${translator("COL_Person_HasAlreadyVM_Until")}${clearanceDate}`;
                }

                if ($controller.s.HasOtherScreening)
                    return translator("COL_Person_AlreadyBeingScreened");

                return translator("COL_Person_HasAlreadyVM_NoDate");
            }

            if (isFilteringOnStatus(screening.Status)) {
                return getDefaultDetails(screening.Status, screening.ResultCode);
            }

            return getAlreadyProcessedText(screening);
        }

        function isFilteringOnStatus(status) {
            if (!$controller.filter)
                return false;

            return status == Number.parseInt($controller.filter.Status);
        }

        function getDefaultDetails(screeningStatus, resultCode) {
            switch (screeningStatus) {
                case enumService.ScreeningStatusCode.Completed:
                    const result = $rootScope.codeScreeningResults.find(c => c.Key === resultCode);
                    return result ? result.Value : "";
                case enumService.ScreeningStatusCode.Rejected:
                    return translator("Screening_SentBackTo_NSA");
            }

            return "";
        }

        function showMotivation() {
            if (!$controller.s.ActionRemark)
                return;

            habilBootbox.alert({                
                title: translator("AdditionalMotivation_ChosenAction"),
                message: $controller.s.ActionRemark,
                callback: angular.noop
            });
        }

        function hasActions() {
            return canAnswer() || canStop() || canOpen() || canReopen() || canDownload();
        }
    }
})();